document.addEventListener("DOMContentLoaded", function () {
  const steps = document.querySelectorAll(".survey-step");
  let currentStep = 0;

  function showStep(stepIndex) {
    steps.forEach((step, index) => {
      step.style.display = index === stepIndex ? "block" : "none";
    });
  }

  function validateStep(stepIndex) {
    const currentStep = steps[stepIndex];
    const inputs = currentStep.querySelectorAll(".survey-input");
    let isValid = true;

    inputs.forEach((input) => {
      const required = input.dataset.required === "true";
      if (required && !input.value.trim()) {
        isValid = false;
        currentStep.querySelector(".required-message").style.display = "block";
      } else {
        currentStep.querySelector(".required-message").style.display = "none";
      }
    });

    return isValid;
  }

  document.querySelectorAll(".next-step").forEach((button, index) => {
    button.addEventListener("click", () => {
      if (validateStep(currentStep)) {
        currentStep++;
        showStep(currentStep);
      }
    });
  });

  document.querySelectorAll(".prev-step").forEach((button) => {
    button.addEventListener("click", () => {
      currentStep--;
      showStep(currentStep);
    });
  });

  document.querySelectorAll(".submit-survey").forEach((button) => {
    button.addEventListener("click", () => {
      if (validateStep(currentStep)) {
        document.getElementById("survey-container").style.display = "none";
        document.getElementById("thank-you-message").style.display = "block";
      }
    });
  });
});
